export default __webpack_public_path__ + "static/media/LaganValleyED-NIASReferral-PhoneFirstservicev1220707LVHPhonefirstEDv1_flowchart.5f6d0ba4.jpg";